module.exports = __webpack_public_path__ + "static/logo-97fd8cc642e3e73905a6253c1bebd787.png";